import { render } from "./PrimaryCareDataTable.vue?vue&type=template&id=6daf2d32&scoped=true&lang=pug"
import script from "./PrimaryCareDataTable.vue?vue&type=script&lang=js"
export * from "./PrimaryCareDataTable.vue?vue&type=script&lang=js"

import "./PrimaryCareDataTable.vue?vue&type=style&index=0&id=6daf2d32&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6daf2d32"]])

export default __exports__